import dayjs from 'dayjs'
import { isEqual } from 'lodash'
import React from 'react'
import {
  Calendar as ReactBigCalendar,
  dayjsLocalizer,
} from 'react-big-calendar'

import { BigCalendarCellWrapper } from './components/cell-wrapper/BigCalendarCellWrapper'
import { BigCalendarHeaderICalendarImportProps } from './components/header/components/BigCalendarHeaderImportButton'
import { BigCalendarToolbar } from './components/toolbar/BigCalendarToolbar'
import { BigCalendarMonth } from './utils/use-big-calendar'
import { useBigCalencarFormContext } from './utils/use-big-calendar-form'
import { useLocale } from '../../../../../../hooks/use-locale'
import { HouseContext } from '../../../../../../lib/graphql'
import { convertTimezonedDateToIsoAtMidnight } from '../../../../../../utils/date-helpers'
import { Loader } from '../../../../../molecules'

const DAY_JS_LOCALIZER = dayjsLocalizer(dayjs)

export type BigCalendarProps = Pick<
  BigCalendarHeaderICalendarImportProps,
  'onUpdateICalendarUrls'
> & {
  house: NonNullable<HouseContext>
  calendarMonth: BigCalendarMonth
}
export const BigCalendar = React.memo(
  ({ calendarMonth, house }: BigCalendarProps) => {
    const { locale } = useLocale()
    const { date } = calendarMonth
    const { handleOnSelectSlot } = useBigCalencarFormContext()

    return (
      <>
        {date ? (
          <ReactBigCalendar
            events={[]}
            localizer={DAY_JS_LOCALIZER}
            culture={locale}
            date={convertTimezonedDateToIsoAtMidnight(date.toDate())}
            components={{
              toolbar: () => (
                <BigCalendarToolbar
                  calendarMonth={calendarMonth}
                  house={house}
                />
              ),
              month: { dateHeader: ({ label }) => <span>{label}</span> },
              dateCellWrapper: (props) => (
                <BigCalendarCellWrapper {...props} house={house} />
              ),
            }}
            selectable={true}
            onSelectSlot={(slotInfo) => handleOnSelectSlot({ house, slotInfo })}
          />
        ) : (
          <Loader />
        )}
      </>
    )
  },
  (prevProps, nextProps) => {
    const prev = {
      options: prevProps.house.options,
      availabilities: prevProps.house.availabilities,
    }
    const next = {
      options: nextProps.house.options,
      availabilities: nextProps.house.availabilities,
    }

    return isEqual(prev, next)
  },
)
